(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["main_menu.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\r\n";
var macro_t_1 = runtime.makeMacro(
["name"], 
[], 
function (l_name, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("name", l_name);
var t_2 = "";t_2 += "\r\n    ";
if(env.getFilter("replace").call(context, runtime.contextOrFrameLookup(context, frame, "_route"),"_calendar","") != runtime.contextOrFrameLookup(context, frame, "_route")) {
t_2 += "\r\n        <li><a href=\"";
t_2 += runtime.suppressValue((lineno = 6, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, [l_name + "_calendar_index"])), env.opts.autoescape);
t_2 += "\"";
if(runtime.contextOrFrameLookup(context, frame, "_menu") == l_name) {
t_2 += " class=\"active\"";
;
}
t_2 += ">";
t_2 += runtime.suppressValue(env.getFilter("trans").call(context, ("menu." + l_name)), env.opts.autoescape);
t_2 += "</a></li>\r\n    ";
;
}
else {
t_2 += "\r\n        <li><a href=\"";
t_2 += runtime.suppressValue((lineno = 8, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, [l_name + "_index"])), env.opts.autoescape);
t_2 += "\"";
if(runtime.contextOrFrameLookup(context, frame, "_menu") == l_name) {
t_2 += " class=\"active\"";
;
}
t_2 += ">";
t_2 += runtime.suppressValue(env.getFilter("trans").call(context, ("menu." + l_name)), env.opts.autoescape);
t_2 += "</a></li>\r\n    ";
;
}
t_2 += "\r\n";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("menuitem");
context.setVariable("menuitem", macro_t_1);
output += "\r\n<ul class=\"menu\">\r\n    ";
output += runtime.suppressValue((lineno = 12, colno = 13, runtime.callWrap(macro_t_1, "menuitem", context, ["publications"])), env.opts.autoescape);
output += "\r\n    ";
output += runtime.suppressValue((lineno = 13, colno = 13, runtime.callWrap(macro_t_1, "menuitem", context, ["first_releases"])), env.opts.autoescape);
output += "\r\n    ";
output += runtime.suppressValue((lineno = 14, colno = 13, runtime.callWrap(macro_t_1, "menuitem", context, ["stadat"])), env.opts.autoescape);
output += "\r\n    ";
output += runtime.suppressValue((lineno = 15, colno = 13, runtime.callWrap(macro_t_1, "menuitem", context, ["dissem_db"])), env.opts.autoescape);
output += "\r\n    ";
output += "\r\n    ";
output += "\r\n</ul>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
